import { useState } from 'react';
import { styled } from '@mui/system';
import { Box, Avatar, Menu, Drawer } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';
import { selectAvatar } from '../../../../../store/auth/authSlice';
import LinkItems from '../LinkItems';
import UserMenuItems from '../UserMenuItems';
import { DEFAULT_AVATAR } from '../../../../../utils/constant';

const NavToolOuterContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
});

const NavToolContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: 'calc(100% - 20px)',
  maxWidth: '1100px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const Search = styled('a')(({ theme }) => ({
  fontFamily: 'Caveat',
  color: 'rgba(255, 255, 255, 0.6)',
  fontSize: '24px',
  textDecoration: 'none',
  [theme.breakpoints.down('sm')]: {
    fontFamily: 'Raleway',
    fontSize: '16px',
  },
}));

const ActionsOnTheNavBarRight = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  listStyle: 'none',
});

const MenuStyle = {
  elevation: 0,
  sx: {
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    mt: 1.5,
    '& .MuiAvatar-root': {
      width: 145,
      height: 225,
      ml: -0.5,
      mr: 1,
    },
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
    },
  },
};

const BorderedAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'menuActive',
})(({ menuActive, theme }) => ({
  border: '3px solid #fff',
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    marginRight: `${menuActive ? '160px' : '15px'}`,
    height: '28px',
    width: '28px',
    borderWidth: '2px',
  },
}));

const UserDrawer = styled(Drawer)({
  '& .MuiPaper-root': {
    width: '146px',
    overflow: 'unset',
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: '20px',
      right: '140px',
      width: '10px',
      height: '10px',
      backgroundColor: '#fff',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: '0',
    },
  },
});

const UserTools = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const mobileMatch = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    mobileMatch ? setOpenDrawer(true) : setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const Avatar = useSelector(selectAvatar);

  return (
    <NavToolOuterContainer>
      <NavToolContainer>
        <Search href="/search">Search</Search>
        <ActionsOnTheNavBarRight>
          {!mobileMatch && <LinkItems />}

          <BorderedAvatar
            src={Avatar || DEFAULT_AVATAR}
            onClick={handleClick}
            size="small"
            sx={{ borderColor: open ? '#AA9178' : 'white' }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            menuActive={openDrawer}
          />
          {mobileMatch ? (
            <UserDrawer
              anchor={'right'}
              open={openDrawer}
              onClose={() => {
                setOpenDrawer(false);
              }}
            >
              <UserMenuItems handleLogOut={props.handleLogOut} />
            </UserDrawer>
          ) : (
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={MenuStyle}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <UserMenuItems handleLogOut={props.handleLogOut} />
            </Menu>
          )}
        </ActionsOnTheNavBarRight>
      </NavToolContainer>
    </NavToolOuterContainer>
  );
};

export default UserTools;
